<template>
  <el-dialog title="查看大区" :visible.sync="formVisible" :close-on-click-modal="false" width="1000px">
    <div class="filter-container">
      <el-form :model="query" ref="queryForm" :inline="true">
        <el-form-item label="业务员信息：" prop="nameOrPho">
          <el-input v-model="query.nameOrPho" placeholder="请输入姓名/手机号" size="small" clearable />
        </el-form-item>
        <el-form-item label="上级手机号：" prop="parentPho">
          <el-input v-model="query.parentPho" placeholder="请输入上级手机号" size="small" clearable />
        </el-form-item>
        <el-form-item label="权益状态：">
          <el-select v-model="query.state" placeholder="请选择" size="small">
            <el-option label="全部" :value="-1"></el-option>
            <el-option label="已授权" :value="1"></el-option>
            <el-option label="未授权" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="width100">
          <div class="flexs justify-end w-100">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="flexs justify-between w-100 mb10">
      <div>大区人数：{{number}}</div>
      <el-button type="primary" size="mini" @click="handleAdd" icon="el-icon-plus">新增</el-button>
    </div>
    <el-table v-loading="listLoading" :data="list">
      <el-table-column label="业务员信息" prop="" align="center" fixed>
        <template slot-scope="{row}">
          <div>{{row.name}}({{row.levelName}})</div>
          <div>{{row.pho}}</div>
        </template>
      </el-table-column>
      <el-table-column label="上级信息" prop="name" align="center" width="160" fixed>
        <template slot-scope="{row}">
          <div>{{row.parentName}}({{row.parentLevelName}})</div>
          <div>{{row.parentPho}}</div>
        </template>
      </el-table-column>
      <el-table-column label="管辖区域数量" prop="areaCount" align="center" />
      <el-table-column label="下级团队人数" prop="childCount" sortable align="center" />
      <el-table-column label="权益状态" prop="companyAreaNum" align="center">
        <template slot-scope="{row}">
          {{row.state?'已授权':'未授权'}}
        </template>
      </el-table-column>
      <el-table-column label="加入时间" prop="joinTime" sortable align="center" width="200">
        <template slot-scope="{row}">
          {{dayjs(row.joinTime).format("YYYY-MM-DD HH:mm:ss")}}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="60">
        <template slot-scope="{row}">
          <el-button type="text" @click="handleDel(row)">移除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="getList" style="padding-right: 50px;" />

  </el-dialog>
</template>

<script>
import cityCompanyApi from '@/api/sys/cityCompany'

function initFormBean() {
  const formBean = {
    name: null,
    areaId: null,
    chargeName: null,
    pho: null,
    addrDetail: null,
    state: true
  }
  return formBean
}

export default {
  props: {
    addressList: Array
  },
  data() {
    return {
      form: initFormBean(),
      formVisible: false,
      selectItems: [],
      query: {
        pageNo: 1,
        pageSize: 5,
        state: -1
      },
      list: [],
      listLoading: true,
      total: 0,
      number: 0,
      id: null
    }
  },
  created() {

  },
  methods: {
    handleFilter() {
      this.query = {
        pageNo: 1,
        pageSize: 5
      }
      this.getList()
    },
    resetForm() {
      this.form = initFormBean()
    },
    getList() {
      cityCompanyApi.getRegionList({
        ...this.query,
        cityCompanyId: this.id
      }).then(({
        data
      }) => {
        console.log('列表: ', data);
        this.list = data.list
        this.total = data.total
      }).finally(() => {
        this.listLoading = false
      })
    },
    handleCreate({
      id,
      num
    }) {
      this.query = {
        pageNo: 1,
        pageSize: 5
      }
      this.id = id
      this.number = num
      this.resetForm()
      this.formVisible = true
      this.getList()
    },
    handleAdd() {
      this.$router.push("/business/businessList");
    },
    handleDel(row) {
      this.$common.confirm('是否确认移除该大区').then(() => cityCompanyApi.deleteById({
        customerId: row.customerId
      }).then((res) => {
        this.$message.success('操作成功')
        this.getList()
        this.$emit('created')
      }));
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.query.pageNo = 1
      this.getList()
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-select {
  width: 100%;
}

::v-deep .el-cascader {
  width: 100%;
}

::v-deep .el-input {
  width: 100%;
}

.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}

.el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
  width: 100%;
}

.el-form-item.width100 {
  width: 95%;

  ::v-deep .el-form-item__content {
    width: 100%;
  }
}
</style>
